import StudyModel from '@/models/study'

const studyModel = new StudyModel()
const MUTATION_TYPES = {
  SET_PROMPT: 'SET_PROMPT',
  CODES: [2000, 2001, 2004, 2009, 2007, 2008, 2010, 2006, 2011, 710, 2012]
}

export default {
  namespaced: true,
  state: {
  },
  getters: state => state.prompts,
  mutations: {
    [MUTATION_TYPES.SET_PROMPT] (state, info) {
      state[info.code] = info
    }
  },
  actions: {
    async [MUTATION_TYPES.SET_PROMPT] (context) {
      const res = await studyModel.studyPrompt({ codeStrs: MUTATION_TYPES.CODES.join(','), pageType: 6 })

      if (res && res.data) {
        const data = res.data
        for (let i = 0; i < data.length; i++) {
          context.commit(MUTATION_TYPES.SET_PROMPT, data[i])
        }
      }

    }
  }
}
